export const appVersion = __APP_VERSION__;
export const appBuildSha = __APP_BUILD_SHA__;
export const appBuildTime = __APP_BUILD_TIME__;

export function formattedBuildTime(locale = 'nb-NO'): string {
  const date = new Date(appBuildTime);
  if (Number.isNaN(date.getTime())) return appBuildTime;
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
